import React, { useEffect, useRef, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { MdKeyboardDoubleArrowRight } from "react-icons/md";
import { MdKeyboardArrowLeft } from "react-icons/md";
import _constantUtil from "../../../utils/Constant";  
import moment from "moment";
import { MdCreate } from "react-icons/md"; 
import profile from '../../../assets/small-logo-512x512.png' 
import DatePicker from "react-datepicker";

function UpdateMatch() {
    const navigate = useNavigate() 
    const storedTheme = sessionStorage.getItem("themeMode"); 
    const location = useLocation()
    const Mstate = location.state?.Mcount ?? 0

    const [profileImage, setProfileImage] = useState(profile);
    const [profileImage2, setProfileImage2] = useState(profile);
    const [profileImage3, setProfileImage3] = useState("");
    const [confirmation, setConfirmation] = useState(_constantUtil.FALSE); 
    const [startDate, setStartDate] = useState(new Date());
    const [endDate, setEndDate] = useState(moment().add(1, "days").toDate());

    const handleImageChange = (event, setter) => {
        const file = event.target.files[_constantUtil.ZERO];
        const reader = new FileReader();
        reader.onload = (event) => {
            setter(event.target.result);
        };
        reader.readAsDataURL(file);
    };
 
    const confirmationRef = useRef(_constantUtil.NULL);
    useEffect(() => {
        // viewMatch();

        const handleClickOutside = (event) => {
            if (
                confirmationRef.current &&
                !confirmationRef.current.contains(event.target)
            ) {
                setConfirmation(_constantUtil.FALSE);
            }
        };

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    const handleStartDateChange = (date, e) => {
        setStartDate(date);
        const oneDayFromStartDate = moment(date).add(1, "days").toDate();
        setEndDate(oneDayFromStartDate);
    };

    const handleKeyDown = (e) => {
        if (e.key === "Backspace") {
            e.preventDefault();
        }
    };
    return (
        <> 
                {confirmation && (
                <div>
                    <div className="team-confirmation-overlay"></div>
                    <div
                        ref={confirmationRef}
                        className={`${
                            storedTheme === "dark"
                                ? "match-dark-confirmation-dialog"
                                : "match-light-confirmation-dialog"
                        }`}
                    >
                        <div className="d-flex justify-content-between">
                            <h4>Edit Player Info</h4>
                        </div>

                        <div className=" text-center">
                            <img
                                src={profileImage3}
                                alt="Profile"
                                className="img-thumbnail img-fluid mt-4"
                                style={{
                                    borderRadius: "50%",
                                    cursor: "pointer",
                                    objectFit: "cover",
                                    minHeight: "170px",
                                    height: "170px",
                                    maxWidth: "170px",
                                    width: "170px",
                                    backgroundColor: "transparent",
                                }}
                            />
                            <div className="button-wrapper pt-2">
                                <span className="label blr-bg-dull-sky rounded">
                                    <p className="mb-0 px-1">Upload File</p>
                                </span>
                                <div className="d-flex justify-content-center">
                                    <input
                                        type="file"
                                        accept="image/*"
                                        onChange={(event) =>
                                            handleImageChange(
                                                event,
                                                setProfileImage3
                                            )
                                        }
                                        className=" upload-box form-control"
                                        name="upload"
                                        id="upload-modal"
                                        placeholder="Upload File"
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="mb-2">
                            <label
                                htmlFor="player_name"
                                className="form-label fw-semibold"
                            >
                                Player Name
                            </label>
                            <input
                                type="text"
                                className="form-control"
                                style={{ backgroundColor: "transparent" }}
                                id="player_name"
                                name="player_name"
                                placeholder="name"
                                autoComplete="off"
                            />
                        </div>
                        <div className="mb-2">
                            <label
                                htmlFor="type"
                                className="form-label fw-semibold"
                            >
                                Player Type
                            </label>
                            <select
                                className="form-select me-2"
                                style={{ backgroundColor: "transparent" }}
                            >
                                <option value="goalkeeper">Goalkeeper</option>
                                <option value="defender">Defender</option>
                                <option value="midfielder">Midfielder</option>
                                <option value="attacker">Attacker</option>
                            </select>
                        </div>
                        <div className="mb-2">
                            <label
                                htmlFor="credit"
                                className="form-label fw-semibold"
                            >
                                Player Credit
                            </label>
                            <select
                                className="form-control"
                                style={{ backgroundColor: "transparent" }}
                            >
                                <option value="1">1</option>
                                <option value="1.5">1.5</option>
                                <option value="2">2</option>
                                <option value="2.5">2.5</option>
                                <option value="3">3</option>
                                <option value="3.5">3.5</option>
                                <option value="4">4</option>
                                <option value="4.5">4.5</option>
                                <option value="5">5</option>
                                <option value="5.5">5.5</option>
                                <option value="6">6</option>
                                <option value="6.5">6.5</option>
                                <option value="7">7</option>
                                <option value="7.5">7.5</option>
                                <option value="8">8</option>
                                <option value="8.5">8.5</option>
                                <option value="9">9</option>
                                <option value="9.5">9.5</option>
                                <option value="10">10</option>
                                <option value="10.5">10.5</option>
                                <option value="11">11</option>
                            </select>
                        </div>

                        <div className="d-flex justify-content-end mt-3">
                            <button
                                onClick={() => setConfirmation(false)}
                                className="border-0 rounded px-3 bg-danger text-white me-2 p-2"
                            >
                                Cancel
                            </button>
                            <button className="border-0 rounded px-3 bg-success text-white p-2">
                                Save
                            </button>
                        </div>
                    </div>
                </div>
            )}

            <div className="">
                <div className="row justify-content-center mx-4">
                    <div className="d-flex align-items-center justify-content-between p-0">
                        <h4 className="header-title mb-0 text-muted mt-3"> 
                            <Link
                                onClick={() => navigate(-1)}
                                className="header-sub-title"
                            >
                                 {Mstate === 1 ? 'Upcoming Match' : 'Launched Match'}
                            </Link>
                            <span className="blr-player-view">
                                <MdKeyboardDoubleArrowRight className="jumbo-red-text mb-1 ms-2 " />
                            </span>{" "}
                            Update Match
                        </h4>
                        <div className="d-flex align-items-center  mt-3"> 
                            <button
                                type="button"
                                className="btn text-white d-flex"
                                style={{ float: "right" }}
                                onClick={() => navigate(-1)}
                            >
                                <MdKeyboardArrowLeft className=" fs-4" />
                                Back
                            </button>
                        </div>
                    </div>
                    <div className="card px-4 mt-3">
                        <div className="card-body">
                        <form>
                                <div className="row flex-column align-items-center flex-md-row p-0  mt-2">
                                    <div className=" col-12 col-md-6 col-lg-6 mb-1 img-responsive padding-responsive  ">
                                        <div className="card ">
                                            <div className="card-body d-flex   align-items-center">
                                                <div className=" d-flex flex-column align-items-center order-md-0 mb-md-0">
                                                    <span className="label rounded img-label">
                                                        <p
                                                            className="mb-0 d-flex align-items-center justify-content-center"
                                                            style={{
                                                                background:
                                                                    "#8080804f",
                                                                borderRadius:
                                                                    "50px",
                                                                padding: "4px",
                                                            }}
                                                        >
                                                            <MdCreate />
                                                        </p>
                                                    </span>
                                                    <img
                                                        src={profileImage}
                                                        alt="Profile"
                                                        className="img-thumbnail img-fluid mb-2"
                                                        style={{
                                                            borderRadius: "50%",
                                                            cursor: "pointer",
                                                            objectFit: "cover",
                                                            minHeight: "100px",
                                                            height: "100px",
                                                            maxWidth: "100px",
                                                            width: "100px",
                                                            border: "none",
                                                        }}
                                                    />
                                                    <div className="d-flex justify-content-center">
                                                        <input
                                                            type="file"
                                                            accept="image/png, image/jpeg, image/jpg"
                                                            onChange={(event) =>
                                                                handleImageChange(
                                                                    event,
                                                                    setProfileImage
                                                                )
                                                            }
                                                            className="upload-box form-control"
                                                            name="upload file"
                                                            id="upload-match-img"
                                                            placeholder="Upload File"
                                                        />
                                                    </div> 
                                                        <label
                                                            htmlFor="team_one"
                                                            className="form-label"
                                                        >
                                                            Team 01
                                                        </label>
                                                        <input
                                                            type="text"
                                                            className="form-control mb-2"
                                                            id="team_one"
                                                            name="eam_one" 
                                                            style={{width:'50%'}}
                                                            placeholder="Enter Team 01"
                                                            autoComplete="off"
                                                        />
                                                    </div>  
                                                <div>
                                                    <h3 className="text-muted">
                                                        VS
                                                    </h3>
                                                </div>
                                                <div className="d-flex flex-column align-items-center order-md-0 mb-md-0">
                                                    <span className="label rounded img-label">
                                                        <p
                                                            className="mb-0 d-flex align-items-center justify-content-center"
                                                            style={{
                                                                background:
                                                                    "#8080804f",
                                                                borderRadius:
                                                                    "50px",
                                                                padding: "4px",
                                                            }}
                                                        >
                                                            <MdCreate />
                                                        </p>
                                                    </span>
                                                    <img
                                                        src={profileImage2}
                                                        alt="Profile"
                                                        className="img-thumbnail img-fluid mb-2 "
                                                        style={{
                                                            borderRadius: "50%",
                                                            cursor: "pointer",
                                                            objectFit: "cover",
                                                            minHeight: "100px",
                                                            height: "100px",
                                                            maxWidth: "100px",
                                                            width: "100px",
                                                            border: "none",
                                                        }}
                                                    />
                                                    <div className="d-flex justify-content-center">
                                                        <input
                                                            type="file"
                                                            accept="image/png, image/jpeg, image/jpg"
                                                            onChange={(event) =>
                                                                handleImageChange(
                                                                    event,
                                                                    setProfileImage2
                                                                )
                                                            }
                                                            className="upload-box form-control"
                                                            name="upload file"
                                                            id="upload-match-img-2"
                                                            placeholder="Upload File"
                                                        />
                                                    </div>
                                                    <label
                                                            htmlFor="team_two"
                                                            className="form-label"
                                                        >
                                                            Team 02
                                                        </label>
                                                        <input
                                                            type="text"
                                                            className="form-control mb-2"
                                                            id="team_two"
                                                            name="team_two" 
                                                            placeholder="Enter Team 02"
                                                            style={{width:'50%'}}
                                                            autoComplete="off"
                                                        /> 
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="col-lg-6 col-md-6 col-12 mb-1  padding-responsive">
                                        <div className="card ">
                                            <div className="card-body">
                                                <div className="row  ">
                                                    <div className="table-responsive px-0">
                                                        <table className="table m-0 ">
                                                            <tbody className="blr-line-height-table ">
                                                                <tr className="py-1">
                                                                    <td className="fw-bold text-nowra">
                                                                        Match 
                                                                    </td>
                                                                    <td>
                                                                        <input
                                                                            type="text" 
                                                                            defaultValue="IND vs PAK" 
                                                                            className="text-center"
                                                                            style={{
                                                                                border: "none",
                                                                                background:
                                                                                    "transparent",
                                                                            }}
                                                                        />
                                                                    </td>
                                                                </tr>
                                                                <tr>
                                                                    <td className="fw-bold"  style={{whiteSpace:'nowrap'}} >
                                                                       Start Date &
                                                                        Time
                                                                    </td>
                                                                    <td   >
                                                                    <div className="d-flex align-items-center justify-content-center">
                                                                        <DatePicker
                                                                            selected={startDate}
                                                                            onChange={handleStartDateChange}
                                                                            minDate={new Date()}
                                                                            onKeyDown={handleKeyDown}
                                                                            dateFormat="yyyy/MM/dd"
                                                                            className="form-control   text-center"
                                                                            showDisabledMonthNavigation
                                                                        />
                                                                        <span className="px-2">
                                                                            <DatePicker
                                                                            selected={startDate}
                                                                            onChange={handleStartDateChange}
                                                                            showTimeSelect
                                                                            showTimeSelectOnly
                                                                            timeIntervals={15} // 15-minute intervals
                                                                            dateFormat="HH:mm"
                                                                            className="form-control   text-center"
                                                                            minTime={moment().startOf('day').toDate()} // Restrict time selection
                                                                            maxTime={moment().endOf('day').toDate()}
                                                                            />
                                                                        </span>
                                                                        </div>
                                                                    </td>
                                                                </tr>  
                                                                <tr>
                                                                    <td className="fw-bold"   >
                                                                       End Date &
                                                                        Time
                                                                    </td>
                                                                    <td   >
                                                                    <div className="d-flex align-items-center justify-content-center">
                                                                        <DatePicker
                                                                            selected={endDate}
                                                                            onChange={setEndDate}
                                                                            minDate={moment(startDate).add(1, 'days').toDate()}
                                                                            onKeyDown={handleKeyDown}
                                                                            dateFormat="yyyy/MM/dd"
                                                                            className="form-control   text-center"
                                                                            showDisabledMonthNavigation
                                                                        />
                                                                        <span className="px-2">
                                                                            <DatePicker
                                                                            selected={endDate}
                                                                            onChange={setEndDate}
                                                                            showTimeSelect
                                                                            showTimeSelectOnly
                                                                            timeIntervals={15}
                                                                            dateFormat="HH:mm"
                                                                            className="form-control   text-center"
                                                                            minTime={moment().startOf('day').toDate()}
                                                                            maxTime={moment().endOf('day').toDate()}
                                                                            />
                                                                        </span>
                                                                        </div>
                                                                    </td>
                                                                </tr>
                                                                <tr
                                                                    style={{
                                                                        borderBottom:
                                                                            "hidden",
                                                                    }}
                                                                >
                                                                    <td className="fw-bold">
                                                                        Delay
                                                                        Time
                                                                    </td>
                                                                    <td>
                                                                        <div className="d-flex align-items-center justify-content-center">
                                                                            <div className="me-2 mt-1">
                                                                                <select
                                                                                    className="form-select text-center"
                                                                                    style={{
                                                                                        width: "100%",  
                                                                                    }}
                                                                                >
                                                                                    <option value="0">
                                                                                        0
                                                                                    </option>
                                                                                    <option value="5">
                                                                                        5
                                                                                    </option>
                                                                                    <option value="-5">
                                                                                        -5
                                                                                    </option>
                                                                                    <option value="15">
                                                                                        15
                                                                                    </option>
                                                                                    <option value="-15">
                                                                                        -15
                                                                                    </option>
                                                                                    <option value="30">
                                                                                        30
                                                                                    </option>
                                                                                    <option value="-30">
                                                                                        -30
                                                                                    </option>
                                                                                    <option value="45">
                                                                                        45
                                                                                    </option>
                                                                                    <option value="-45">
                                                                                        -45
                                                                                    </option>
                                                                                    <option value="60">
                                                                                        60
                                                                                    </option>
                                                                                    <option value="-60">
                                                                                        -60
                                                                                    </option>
                                                                                </select>
                                                                            </div>
                                                                            <div className="">
                                                                                <button
                                                                                    type="button"
                                                                                    className="btn text-white"
                                                                                >
                                                                                    Save
                                                                                </button>
                                                                            </div>
                                                                        </div>
                                                                    </td>
                                                                </tr>
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="row mb-2">
                                    <div className="mb-1 col-12 col-md-12 col-lg-6 mt-1"> 
                                        <label htmlFor='tournament_select' className='form-label'>
                                            Select Tournament
                                        </label>
                                        <select
                                            id='tournament_select'
                                            className='form-select me-2' 
                                        >
                                            <option  value=''>Select Tournament</option>
                                            <option  value='premierleague'>Premier League</option>  
                                        </select> 
                                    </div>
                                    <div className="col-lg-6 col-md-12 col-12 mb-3">
                                        <div className="mt-1">
                                            <label
                                                htmlFor="known_name"
                                                className="form-label"
                                            >
                                                Known Name
                                            </label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                id="known_name"
                                                name="known_name" 
                                                placeholder="Enter Known Name"
                                                autoComplete="off"
                                            />
                                        </div> 
                                    </div> 
                                </div>
                                <button
                                    type="button"
                                    className="btn text-white mb-2"
                                    style={{ float: "right" }}
                                >
                                    Save
                                </button>
                            </form>
                        </div>
                    </div> 
                </div>
            </div>
        </>
    );
}

export default UpdateMatch;
